import React from 'react'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'

import Tooltip from 'components/Tooltip'

type Props = {
  severity: string,
  size?: number,
  title?: string,
  className?: string
}
const ALLOWED_SEVERITIES = ['critical', 'critical-sda', 'major', 'major-sda', 'minor', 'minor-sda'] as const
const AlertIcon = ({ severity, size = 24, title = '', className } : Props) => {
  const normalizedSeverity = ALLOWED_SEVERITIES.includes(severity as typeof ALLOWED_SEVERITIES[number])
    ? severity
    : 'minor'
  return (
    <Tooltip title={title || ''}>
      <S.Container readOnly enabled={!!title}>
        <img src={`/img/${normalizedSeverity.replace('-', '_')}_alert.svg`} alt={`${normalizedSeverity.replace('-', ' ')} alert`} width={size} height={size} className={className} />
      </S.Container>
    </Tooltip>
  )
}

export default AlertIcon

const S = {
  Container: styled(KeyboardAccessible)`
    display: inline-block;
  `
}
